import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { Table } from 'primeng/table';
import { MasterDTO } from '../../model/admin.entity';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';

@Component({
  selector: 'tandc-performance-criteria',
  templateUrl: './performance-criteria.component.html',

})
export class PerformanceCriteriaComponent implements OnInit {

  perfCriteriaList: MasterDTO[] = [];
  model: MasterDTO = new MasterDTO();
  showModal: boolean = false;
  modalTitle: string = "";
  @ViewChild('dt')
  dt!: Table;

  constructor(private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
      private router: Router,
     private masterDataRepository: MasterDataRepository) { }

  ngOnInit(): void {
    this.getAll();
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  getAll() {
    this.service.getPerformanceCriteria().subscribe((x) => {
      this.perfCriteriaList = x.value;
    });
  }

  addModal() {
    this.router.navigate(['admin/save-performance-criteria']);
    this.model = new MasterDTO();
    this.showModal = !this.showModal;
    this.modalTitle =
      this.translate.instant('commonbtn.add') +
      ' ' +
      this.translate.instant('Master.performanceCriteria');
  }

  save(data: MasterDTO) {
    if (data.id > 0) {
      this.service.updatePerformanceCriteria(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.UpdatedSuccessfully')
          );
          this.getAll();
        }
      });
    } else {
      this.service.savePerformanceCriteria(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.SavedSuccessfully')
          );
          this.getAll();
        }
      });
    }
  }

  delete(data: MasterDTO) {
    this.commonService.confirmationService.confirm({
      message: this.translate.instant('Alerts.DeleteConfirmation'),
      accept: () => {
        if (data) {
          this.service.deletePerformanceCriteria(data.id).subscribe((res) => {
            if (res) {
              this.commonService.successMessage(
                this.translate.instant('Alerts.DeleteSuccessfully')
              );
              this.getAll();
            }
          });
        }
      },
    });
  }

    onToggleStatus(item: MasterDTO) {
  const updatedItem = { ...item }; 
  this.service.updatePerformanceCriteria(updatedItem).subscribe({
    next: () => {
      this.commonService.successMessage(
        this.translate.instant('Alerts.UpdatedSuccessfully')
      );
    },
    error: () => {
      this.commonService.errorMessage(
        this.translate.instant('Alerts.ErrorOccured')
      );
      // Revert toggle on error
      item.isActive = !item.isActive;
    }
  });
  }

  edit(data: MasterDTO) {
    this.router.navigate(['admin/save-performance-criteria', data.id]);
    this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('Master.performanceCriteria');
    this.model = data;
    this.showModal = !this.showModal;
  }
    
    downloadFile(blob: Blob, fileName: string): void {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  
    export() {
      this.masterDataRepository.export('performance-criteria').subscribe(blob => {
        this.downloadFile(blob, `performance-criteria-${new Date().toISOString().slice(0,10)}.xlsx`);
      });
    }

}
